// extracted by mini-css-extract-plugin
module.exports = {"workspaceLinkContainer":"WorkspaceLinks_workspaceLinkContainer__ufTr5","workspaceLink":"WorkspaceLinks_workspaceLink__pMeRe"};